module.exports = __webpack_public_path__ + "img/DailyBooks-success.42ff6e3b.png";